import React from 'react';

export default class SidePopup extends React.Component {

    constructor(props) {
        super(props);
        this.clickHandler = this.handleOutsideClick.bind(this);
        this.ref = null;
    }


    componentDidMount() {
        setTimeout(() => {
            window.addEventListener('click', this.clickHandler);

        },100);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.clickHandler);
    }

    handleOutsideClick(e) {
        if (window.innerWidth <= 991) return;

        if (this.ref && !this.ref.contains(e.target)) {
            this.props.onClose();
        }

    }

    render() {
        const { title, children, type, set, back = true, onClose = () => {} } = this.props;
        const isTablet = false;
        return (
            <div className={"side-popup " + (isTablet ? 'slide-in-right ' : 'slide-in-right-tablet ') + ( type ? type : "" )} ref={r => this.ref = r}>
                <div className="utils__row utils__rowSpaceBetween">
                    <h1>{title}</h1>
                    <span className="side-popup__close side-popup__close--large" onClick={onClose}>
                       <img src="/assets/close.svg" />
                   </span>
                </div>
                { children }
            </div>
        )
    }

}
